export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SIDEBAR_BUTTON_ANIMATION = 'SIDEBAR_BUTTON_ANIMATION';